import request from "../../utils/request";
import { fileService } from "@/api/common/file-utils";

export const apiService = {
    saveCook(data) {
        return request({
            url: `/nutrition/cook-method/batch-config`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    getCook(griId) {
        return request({
            url: `/nutrition/cook-method/${griId}`,
            method: "get",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    findCqsAuditor: (data, fiveBitCode) => {
        return request({
            url: `/materialRecord/findCqsAuditor/${fiveBitCode}`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    findFinanceAuditor: (data) => {
        return request({
            url: `/materialRecord/findFinanceAuditor`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    search: (data) => {
        return request({
            url: "/materialRecord/findListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //选择对比物料需要的数据
    findListPage: (data) => {
        return request({
            url: "/material/findListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //Category1 Category2
    findCategory: (data) => {
        return request({
            url: "/category/findCategory",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //Category1 Category2 分页
    findListCategory: (data) => {
        return request({
            url: "/category/findList",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //Category3
    getCategory3: (data) => {
        return request({
            url: "/five-bit-code/findList",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //批量删除物料数据
    deleteBatch: (data) => {
        return request({
            url: "/materialRecord/deleteBatchIds?tmMaterialRecordIds=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //excel下载
    download: (data) => {
        return request({
            url: `materialRecord/download`,
            method: "post",
            data: data,
            responseType: "blob",
            fullResponse: true,
        }).then((resp) =>
            fileService.respToFile(resp, '物料主数据.xlsx')
        );
    },
    //excel下载(历史版本)
    downloadHistoricalVersion: (data) => {
        return request({
            url: `/materialRecord/downloadHistoricalVersion`,
            method: "post",
            data: data,
            responseType: "blob",
            fullResponse: true,
        }).then((resp) =>
            fileService.respToFile(resp, '物料主数据历史版本.xlsx')
        );
    },
    //excel下载(历史版本)
    downloadAllBydc: (data) => {
        return request({
            url: `/materialRecord/downloadAllBydc`,
            method: "post",
            data: data,
            responseType: "blob",
            fullResponse: true,
        }).then((resp) =>
            fileService.respToFile(resp, "最新版本下载.xlsx")
        );
    },
    //物料数据版本对比
    findMaterialRecordEdition: (data) => {
        return request({
            url: "/materialRecord/findMaterialRecordEdition?tmMaterialRecordId=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //物料主数据查询详情
    findOne: (data) => {
        return request({
            url: "/material/findOne?tmMaterialId=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //新增物料数据
    add: (data) => {
        return request({
            url: "/materialRecord/add",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //物料主数据GRI详情(通过GRI编码)
    findOneByCode: (data) => {
        return request({
            url: "/five-bit-code/findOneByCode?fiveBitCode=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //待办进来查id
    findNewMaterialRecord: (data) => {
        return request({
            url: "/materialRecord/findNewMaterialRecord?materialId=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //查询结算单位(根据编码)
    findSettlementUnitByCode: (data) => {
        return request({
            url: "/settlementUnit/findSettlementUnitByCode?supplierCode=" + data,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //查询结算单位(分页)
    findSettlementUnitListPage: (data) => {
        return request({
            url: "/settlementUnit/findSettlementUnitListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //查询工厂(分页)
    findPlantListPage: (data) => {
        return request({
            url: "/settlementUnit/findPlantListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //查询DCS(分页)
    findDcsListPage: (data) => {
        return request({
            url: "/settlementUnit/findDcsListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //查询DCS(不分页)
    findDcsList: (data) => {
        return request({
            url: "/settlementUnit/findDcsList",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //分类负责人查询
    categoryLeaderList: (data) => {
        return request({
            url: "/categoryLeader/findList",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //物料主数据GRI查询(分页)
    findGriList: (data) => {
        return request({
            url: "/five-bit-code/findListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    //物料下放MDM
    sendMaterialToMDM: (data, noError) => {
        return request({
            url: `/materialRecord/sendMaterialToMDM?noError=${noError}`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    // 点击RPF禁用接口之前先调用此接口
    checkBatchProductFreightForMaterial: (data) => {
        return request({
            url: `/materialRecord/checkBatchProductFreightForMaterial?tmMaterialRecordIds=${data}`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    //获取主键
    queryPrimaryKey: () => {
        return request({
            url: "materialRecord/findSixBitCode",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    getFPAList: (data) => {
        return request({
            url: "fpaPqcnSummary/findListPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    funDisable: (data) => {
        return request({
            url: "fpaPqcnSummary/update",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    getLogId: () => {
        return request({
            url: "fpaPqcnSummary/getLogId",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    sendPriceTouch: (data) => {
        return request({
            url: "materialRecord/sendPriceTouch",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    findLogPage: (data) => {
        return request({
            url: "fpaPqcnSummary/findLogPage",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    fpaByLately: () => {
        return request({
            url: "five-bit-code/fpaByLately",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },
    disableBatch: (data) => {
        return request({
            url: `materialRecord/disableBatch?tmMaterialRecordIds=${data}`,
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    },

    disableFreightBatch: (data) => {
        return request({
            url: `materialRecord/disableFreight`,
            method: "post",
            data: data,
        });
    },
    // 批量修改
    batchModification: (data) => {
        return request({
            url: `materialRecord/batchModification`,
            method: "post",
            data: data,
        });
    },
    // 撤回
    reCallReq: (data) => {
        return request({
            url: `materialRecord/recall`,
            method: "post",
            data: data,
        });
    },
};